import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerEntryPass, EntryPass} from '../../../../../../../../../models/entry-pass';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { EntryPassService } from '../../../../../../../../../services/entry-pass/entry-pass.service';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { Association, AssociationManager } from '../../../../../../../../../models/association';
import { AssociationService } from '../../../../../../../../../services/association/association.service';
import { CustomerEntryPassStatus, EntryPassStatus } from '../../../../../../../../../models/entry-pass-enums';

@Component({
  selector: 'app-create-customer-entry-pass-modal',
  templateUrl: './create-customer-entry-pass-modal.component.html',
  styleUrls: ['./create-customer-entry-pass-modal.component.css']
})
export class CreateCustomerEntryPassModalComponent implements OnInit {

  @Input() customerId: number;
  @Input() association: Association;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public entryPass: CustomerEntryPass = {
    id: null,
    url: '',
    entry_pass_id: null,
    entry_pass_status: null,
    name: '',
    created_date: null,
    status: CustomerEntryPassStatus.active,
    number_of_uses_total: null,
    number_of_uses_remaining: null,
    expiration_date: '',
    fee_amount: null,
    invoice_id: null,
    invoice_amount: null,
    invoice_tax_amount: null,
    invoice_refunded_amount: null,
    invoice_location_id: null,
    invoice_location_name: null,
    owner_id: null,
    owner_url: null,
    owner_first_name: null,
    owner_last_name: null,
    owner_birthday: null,
    owner_email: null,
    owner_is_member: null,
    owner_association_id: null,
    owner_association_url: null,
    owner_association_name: null,
    owner_association_allow_automatic_entry_pass_use: null,
    all_customer_ids: [],
    all_customers: null,
    customers_less_owner: null,
    unlinked_customers: null,
    created_at: null,
    updated_at: null
  };

  public entryPassList: EntryPass[];
  public associationManagerList: AssociationManager[];

  public loadingEntryPasses = false;
  public loadingAssociationManagers = false;
  public loadingSubmit = false;

  public serverError: number = null;

  public errors: any = {};
  public errorMessage = '';

  public EntryPassStatus = EntryPassStatus;

  constructor(
    private accountService: AccountService,
    private entryPassService: EntryPassService,
    private customerService: CustomerService,
    private associationService: AssociationService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    if (this.association) {
      this.entryPass.owner_association_id = this.association.id;
    }

    this.loadEntryPasses();

    if (!this.customerId) {
      this.loadAssociationManagers();
    }
  }

  public handleSave() {
    this.loadingSubmit = true;
    this.errors = {};
    this.errorMessage = '';

    if (!this.customerId) {
      this.errors.customerId = 'This field is required.';
      this.loadingSubmit = false;
      return;
    }

    if (!this.association) {
      this.entryPass.all_customer_ids = [this.customerId];
    }

    this.customerService
      .addCustomerEntryPass(
        this.customerId,
        this.entryPass
      )
      .then(() => {
        this.savedCallback({
          status: CallbackResultStatus.success,
          text: 'Entry pass created successfully.'
        })
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create entry passes.';
        } else if (reason.status === 400) {
          this.errorMessage = 'Please correct the errors above and try again.';
          this.errors = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadEntryPasses() {
    this.loadingEntryPasses = true;

    this.entryPassService
      .getEntryPasses(1, 100)
      .then(response => {
        this.entryPassList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEntryPasses = false; });
  }

  private loadAssociationManagers() {
    this.loadingAssociationManagers = true;

    this.associationService
      .getAssociationManagers(1, 100, {association_id: this.association.id})
      .then(response => {
        this.associationManagerList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingAssociationManagers = false; });
  }

}
